import siteIcon from '../../public/favicon.png';
import siteLogo from '../../public/images/Plexus_Innovation_Logo.svg';

export default {
  siteName: 'PLEXUS',
  siteIcon: siteIcon,
  siteLogo: siteLogo,
  footerText: `Powered By HSLPlexus Ltd`,
  enableAnimatedRoute: false,
  apiUrl: 'https://plexusdashboardnew-be.azurewebsites.net/',
  google: {
    analyticsKey: 'UA-xxxxxxxxx-1'
  },
  dashboard: '/dashboard'
};
